import axios from 'axios';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { withRouter } from '../../../components/Navigation/withRouter.js';
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardFooter, CardHeader, CardImg, CardText, Col, Container, Form, FormGroup, Input, InputGroup, InputGroupText, Row } from 'reactstrap';
import { PulseLoader } from 'react-spinners';
import * as actions from '../../../store/actions/auth';
import { astrabrand } from '../../../variables/ColorPalette.js';
import { validateInput } from "../../forms/inputValidationUtils/input_validation.js";
import Animo_word_logo2 from '../../../assets/img/Animo_word_logo2.png';

const queryString = require('query-string');
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      email: "",
      forgottenPassword: false,
      successfulSubmit: false,
      verifiedEmail: false,
      isChrome: true,
      validating: false,
      sending: false,
    };
    this.keyPress = this.keyPress.bind(this);
  }
  handleLogin = () => {
    // Perform login here...

    // After login, redirect to the target URL
    const params = new URLSearchParams(history.location.search);
    const targetUrl = params.get('targetUrl');
    history.push(targetUrl || '/default');
  };
  componentDidMount() {
    let browser = (function (agent) {
      switch (true) {
        case agent.indexOf("edge") > -1: return "MS Edge (EdgeHtml)";
        case agent.indexOf("edg") > -1: return "MS Edge Chromium";
        case agent.indexOf("opr") > -1 && !!window.opr: return "opera";
        case agent.indexOf("headless") > -1: return "chrome";
        case agent.indexOf("chrome") > -1 && !!window.chrome: return "chrome";
        case agent.indexOf("trident") > -1: return "Internet Explorer";
        case agent.indexOf("firefox") > -1: return "firefox";
        case agent.indexOf("safari") > -1: return "safari";
        default: return "other";
      }
    })(window.navigator.userAgent.toLowerCase());
    this.setState({ isChrome: browser === 'chrome' })
    this.props.onTryAutoSignup();
    document.body.classList.toggle("login-page");

    if (this.props.url)
      this.setState({ url: this.props.url })
  }

  componentWillReceiveProps(newProps) {
    if (this.props.url !== newProps.url)
      this.setState({ url: newProps.url })
  }

  componentWillUnmount() {
    document.body.classList.toggle("login-page");
  }

  handleSubmit = async e => {
    this.setState({ validating: true })
    // e.preventDefault();
  
    if (this.state.username && this.state.password) {
      try {
        const authResult = await this.props.onAuth(this.state.username, this.state.password, false);
        console.log("WE are getting Auth Results", authResult)
      } catch (error) {
        // handle error
      }
    }
  }
  keyPress(e) {

    if (this.state.username && this.state.password && e.keyCode === 13) {
      this.handleSubmit(e);
      // put the login here
    }
  }

  toggleForgottenPassword() {
    this.setState({
      forgottenPassword: !this.state.forgottenPassword,
    });
  }


  handleForgotPassword = e => {
    e.preventDefault();
    this.setState({ sending: true })

    const user_email = {
      email: this.state.email
    }

    axios.post(this.state.url + 'password_reset/', user_email)
      .then(res => {
        this.setState({
          sending: false,
          successfulSubmit: true
        });
      })
  }
  AuthenticationRoute(props) {
    let pathName = props && props.location && props.location.pathname ? props.location.pathname : null
    let validPath = pathName == '/auth/login' || pathName == '/auth/lock' || pathName == '/auth/change-password' || pathName == '/auth/resetpassword' ? true : false
    const nextPath =  props && props.location && props.location.search?props.location.search:null 
    return validPath ? null : <Navigate replace to={nextPath? "/auth/login" + nextPath:"/auth/login"} />
  }
  render() {
    let errorMessage = null;
    let { usernameState,
      passwordState,
    } = this.state;
    if (this.props.error) {
      usernameState = "has-danger";
      passwordState = "has-danger";
      errorMessage = (
        <p>{this.props.error.message}</p>
      );
    }

    if (this.props.isAuthenticated) {
      if (this.props.passwordResetRequired) {
        if (this.props.token && this.props.navigate) {
          this.props.navigate('/auth/resetpassword/' + this.props.token);
        }
      }
      else {
        var parsed = this.props.location ? queryString.parse(this.props.location.search) : null;
        if (parsed && parsed.next) {
          let url = parsed.next
          let search = "?"
          Object.keys(parsed).forEach(key => {
            if (key !== "next") {
              search += key + "=" + parsed[key] + "&"
            }
          })
          if (search.length > 1) {
            url += search
          }
          if (this.props.navigate) {
            this.props.navigate(url)
          }
        }
        else {
          if (this.props.navigate) {

            const initialPageTarget = sessionStorage.getItem('initial_page_target');
            if (initialPageTarget && initialPageTarget != 'None'&& initialPageTarget != 'undefined'){
              this.props.navigate(`/admin/${initialPageTarget}`);
            }
            else if (this.props.userLevel < 2000 || this.props.userLevel > 10000) {
              this.props.navigate('/admin/dailyCall');
            }
            else {
              this.props.navigate('/admin/activewell');
            }
          }
        }
      }
    }


    return (
      <>
        {this.AuthenticationRoute({ ...this.props })}
        <div className="content">
          <Container>
            <Col className="ml-auto mr-auto" lg="4" md="6">
              <Card className="card-login" style={{ background: "#e1e1e1", border: '2px solid #2c5c69', boxShadow: "0 0 3px 1px #68FDCD" }}>
                <CardHeader style={{ marginBottom: 10 }}>
                  <Row className="justify-content-center">
                    <CardImg
                      alt="..."
                      src={Animo_word_logo2}
                      width="90%"
                      border="100"
                    /><br></br>
                  </Row>
                </CardHeader>
                {this.state.isChrome ?
                  <Form onSubmit={e => { this.handleSubmit(e) }}>
                    {this.state.forgottenPassword ?
                      <CardBody>
                        <h3 style={{ color: astrabrand[6] }}>Reset Password</h3>
                        {this.state.successfulSubmit ?
                          <h4 style={{ color: astrabrand[6] }}>An email has been sent, please follow link when you recieve it</h4> :
                          <h5 style={{ color: astrabrand[6] }}>{"Don't worry, happens to the best of us"}</h5>}
                        <FormGroup className={`has-label ${this.state.emailState}`} style={{ marginTop: 20, color: "Black" }}>
                          <label style={{ color: "Black" }}>Email</label>
                          <Input
                            style={{ color: "Black" }}
                            name="email"
                            type="email"
                            defaultValue={this.state.email}
                            onBlur={e =>
                              validateInput(e, this, "email", "email")
                            }
                          />
                          {this.state.emailState === "has-danger" ? (
                            <label className="error">Valid email is required.</label>
                          ) : null}
                          {/* {!this.state.verifiedEmail && this.state.email ? (
                            <label className="error">Email address isn't recognized, Please try again.</label>
                          ) : null} */}
                        </FormGroup>
                      </CardBody> :
                      <CardBody>
                        <FormGroup className={`has-login ${usernameState}`}>
                          <InputGroup>
                            <InputGroupText style={{ borderColor: "#4f4f4f", background: "#f7f7f7" }}>
                              <i color={astrabrand[1]} className="tim-icons icon-badge animo-icon-success animo-icons-16" />
                            </InputGroupText>
                            <Input style={{ color: "Black", background: "#f7f7f7" }} placeholder="Username" type="text" onChange={e => { this.setState({ username: e.target.value }) }} />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup className={`has-login ${passwordState}`}>
                          <InputGroup>
                            <InputGroupText style={{ borderColor: "#4f4f4f", background: "#f7f7f7" }}>
                              <i className="tim-icons icon-lock-circle animo-icon-success" />
                            </InputGroupText>
                            <Input style={{ color: "Black", background: "#f7f7f7" }} placeholder="Password" type="Password" onKeyDown={this.keyPress} onChange={e => { this.setState({ password: e.target.value, passwordState: "has-success" }) }} />
                          </InputGroup>
                        </FormGroup>
                        {errorMessage ? <CardText style={{ color: astrabrand[7] }} className="pull-left" tag="h5">Email or Password Was Incorrect</CardText> : null}
                      </CardBody>}
                    <CardFooter>
                      {this.state.forgottenPassword ?
                        <Button
                          disabled={this.state.emailState === "has-success" ? false : true}
                          type="submit"
                          block
                          className="mb-2"
                          color={errorMessage ? "warning" : this.state.successfulSubmit ? "success" : "primary"}
                          href="#"
                          onClick={e => { this.handleForgotPassword(e) }}
                          size="lg"
                        >
                          <PulseLoader
                            size={3}
                            margin={'8px'}
                            color={'white'}
                            loading={this.state.sending && !errorMessage}
                          />
                          {this.state.sending && !errorMessage ? "Sending Email" : this.state.successfulSubmit ? "Re-Send Email" : "Email Recovery Link"}
                        </Button> :
                        <Button
                          disabled={this.state.username && this.state.password ? false : true}
                          type="submit"
                          block
                          className="mb-2"
                          color={(this.state.username && this.state.password) ? errorMessage ? "warning" : "success" : "primary"}
                          href="#"
                          onClick={e => { this.handleSubmit(e) }}
                          size="lg"
                        >
                          <PulseLoader
                            size={3}
                            margin={'8px'}
                            color={'white'}
                            loading={this.state.validating && !errorMessage}
                          />
                          {this.state.validating && !errorMessage ? "Verifying" : "Login"}
                        </Button>}
                      <div className="pull-right">
                        <h6 style={{ color: astrabrand[3] }} className="link footer-link"
                          onClick={e => this.toggleForgottenPassword()}
                        >
                          {this.state.forgottenPassword ? "Login" : "Forgot Password"}

                        </h6>
                      </div>
                    </CardFooter>
                  </Form> :
                  <CardBody className="justify-content-center">
                    <h3 style={{ color: astrabrand[6], marginLeft: 6 }}>Please Access Through A Google Chrome Browser</h3>
                    <Row className="justify-content-center">
                      <a
                        href={"https://www.google.com/chrome/"}
                        className="simple-text logo-mini"
                        style={{ marginTop: 10 }}
                        onClick={this.props.closeSidebar}
                      >
                        Download Chrome
                      </a>
                    </Row>
                  </CardBody>}
              </Card>
            </Col>
          </Container>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    obj: [...state.obj],
    loading: state.loading,
    url: state.url,
    error: state.error,
    token: state.token,
    isAuthenticated: state.token !== null,
    userSSO: state.userSSO,
    userLevel: state.userLevel,
    initialPage: state.initialPage,
    passwordResetRequired: state.passwordResetRequired,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onAuth: (username, password) => dispatch(actions.authLogin(username, password)),
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
